import * as React from 'react';
import {ITests} from '../../redux/modules/console/reducer';
import {ConsoleTestsRunning as TestsRunning} from './tests-running';
import {ConsoleTestsResult as TestsResult} from './tests-result';

export interface IConsoleTestsWrapperProps {
  tests: ITests;
  consoleHintShown: boolean;
  ackConsoleScroll: () => void;
}

export const ConsoleTestsWrapper: React.StatelessComponent<IConsoleTestsWrapperProps> = (props) => (
  props.tests && !props.tests.showTests
    ? <TestsRunning />
    : <TestsResult {...props} />
);
